import React from "react";

// Función para serializar los parámetros
const serializeParams = (params) => {
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
};

class Encuesta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userResponse: null,
      submitted: false
    };
  }

  

  handleRating = (rating) => {
    // Guardar la respuesta antes de enviar
    this.setState({ userResponse: rating }, () => {
      const params = {
        respuestaIA: rating
      };

      const serializedParams = serializeParams(params);

      fetch("https://laravel-helpdesk.uaem.mx/api/store-satisfaccion", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: serializedParams
      })
      .then(() => {
        console.log("La solicitud fue enviada");
        this.setState({ submitted: true });
      })
      .catch(error => {
        console.error("Error al enviar la solicitud:", error);
      });
    });
  };

  render() {
    const { submitted } = this.state;

    if (submitted) {
      return <p>Gracias por calificar el chatbot. Tu respuesta ha sido registrada.</p>;
    }

    return (
      <div style={{ textAlign: 'center' }}>
        <p>¿Qué tan útil fue la respuesta del chatbot? (1 = Nada útil, 5 = Muy útil)</p>
        <div>
          {[1, 2, 3, 4, 5].map((num) => (
            <button
              key={num}
              onClick={() => this.handleRating(num)}
              style={{
                margin: '5px',
                padding: '10px 15px',
                fontSize: '16px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                cursor: 'pointer',
              }}
            >
              {num}
            </button>
          ))}
        </div>
      </div>
    );
  }
}

export default Encuesta;
